<template>
  <div>
    <bita-breadcrumb :items="breadCrumbs" />
    <div class="wrapper wrapper-content animated fadeInRight">
      <bita-ibox :is-loading="isLoadingGrid">
        <div slot="body">
          <!-- دکمه حذف فیلتر -->
          <div class="d-flex align-items-center flex-column flex-md-row">
            <bita-bootbutton
              type="danger"
              title="حذف فیلتر"
              class="col-lg-1 mt-3 ml-3"
              style="height: 35px"
              @click.native="reset"
            />
          </div>

          <!-- فیلترهای تاریخ -->
          <div style="text-align: center; margin-bottom: 20px;">
            <transition name="fade">
              <div>
                <hr />
                <bita-form ref="form">
                  <div slot="body">
                    <div class="row">
                      <bita-datepicker
                        ref="fromdate"
                        type="date"
                        id="fromDate"
                        validation-container-class="col-lg-2"
                        name="from-date"
                        label="از تاریخ"
                        inputClass="form-control"
                        v-model="filters.fromDate"
                        @change="search"
                      />
                      <bita-datepicker
                        ref="todate"
                        type="date"
                        id="toDate"
                        validation-container-class="col-lg-2"
                        name="to-date"
                        label="تا تاریخ"
                        inputClass="form-control"
                        v-model="filters.toDate"
                        @change="search"
                      />
                    </div>
                  </div>
                </bita-form>
              </div>
            </transition>
          </div>
          <div class="col-12 col-md-2">
            <bita-filtersbutton
              icon="fas fa-print"
              title="اکسل"
              @click="downloadExcel"
            />
          </div>

          <hr />
          <!-- گرید با پراپ‌های تکمیلی -->
          <bita-grid
            ref="grid"
            :columns="gridColumns"
            :read-data="readData"
            :resizable="true"
          />
        </div>
      </bita-ibox>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      breadCrumbs: [
        { title: "صفحه اصلی", link: "/" },
        {
          title: "گزارش مالی به تفکیک راننده",
          link: "report/wr4",
          active: true,
        },
      ],
      isLoadingGrid: false,
      filters: {
        fromDate: "",
        toDate: "",
      },
    };
  },
  computed: {
    gridColumns() {
      return [
        {
          title: "#",
          template: this.getTemplateID,
          width: "50px",
        },
        {
          field: "driver",
          title: "نام راننده",
          template: (e) => (e && e.driver ? e.driver : "-"),
          width: "150px",
        },
        {
          field: "national_code",
          title: "کد ملی",
          template: (e) => (e && e.national_code ? e.national_code : "-"),
          width: "100px",
        },
        {
          field: "phone",
          title: "شماره موبایل",
          template: (e) => (e && e.phone ? e.phone : "-"),
          width: "110px",
        },
        {
          field: "name",
          title: "نوع تراکنش",
          template: (e) => (e && e.name ? e.name : "-"),
          width: "110px",
        },
        {
          field: "type_id",
          title: "کد تراکنش",
          template: (e) => (e && e.type_id ? e.type_id : "-"),
          width: "110px",
        },
        {
          field: "amount",
          title: "مبلغ",
          template: (e) =>
            e && e.amount ? this.$thousandSeprator(e.amount) : "-",
          width: "90px",
        }
      ];
    },
  },
  methods: {
    getTemplateID(e) {
      // ایمن‌سازی فراخوانی متد داخلی گرید
      if (
        this.$refs.grid &&
        typeof this.$refs.grid.getTemplateLocal === "function"
      ) {
        return this.$refs.grid.getTemplateLocal(e);
      }
      return "#";
    },

    readData(e) {
      this.isLoadingGrid = true;
      let baseUrl = `reports/wr4?from=${this.filters.fromDate || ""}&to=${this
        .filters.toDate || ""}`;
      let url = this.$makeQueryStringForSpatie(baseUrl);

      this.$persistClient("get", url)
        .then((res) => {
          // ارسال داده‌ها به Kendo
          e.success(res.data && res.data.data ? res.data.data : []);
        })
        .catch((err) => {
          console.error("Grid Load Error:", err);
          // در صورت خطا آرایه خالی پاس داده شود تا گرید قفل نشود
          e.success([]);
          // اگر گرید شما از e.error پشتیبانی می‌کند می‌توانید جایگزین کنید: e.error(err)
        })
        .finally(() => {
          this.isLoadingGrid = false;
        });
    },

    loadData() {
      if (
        this.$refs.grid &&
        typeof this.$refs.grid.loadDataSource === "function"
      ) {
        this.$refs.grid.loadDataSource();
      }
    },

    downloadExcel() {
      const params = new URLSearchParams({
        from: this.filters.fromDate || "",
        to: this.filters.toDate || "",
      });

      const url = `${
        this.$apiURL
      }/reports/export-excel-wr4?${params.toString()}&Authorization=${localStorage.getItem("token")}`;
      window.open(url, "_blank");
    },

    // استفاده از Debounce برای جلوگیری از درخواست‌های مکرر هنگام تغییر تاریخ
    search: _.debounce(function() {
      this.loadData();
    }, 1000),

    reset() {
      this.filters = { fromDate: "", toDate: "" };
      this.loadData();
    },
  },
};
</script>

<style scoped>
.label {
  font-family: "iranyekan", sans-serif;
}
.fade-enter {
  opacity: 0;
}
.fade-enter-active,
.fade-leave-active {
  transition: all 1s ease-in;
}
.fade-leave {
  opacity: 0.2;
}
</style>
